import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

// Template132: Día 2 - Cheonggyecheon, Mercado Gwangjang y Myeongdong
// Adaptado del componente PageCheonggyecheon.jsx de guia-seul para usar las props del sistema guia
const Template132 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const cheonggyecheonImage = getImageSrc("cheonggyecheon");
	const myeongdongSticker = getCanvasImageUrl("myeongdong-sticker");
	const mercadoSticker = getCanvasImageUrl("mercado-sticker");
	const oliveYoungImage = getCanvasImageUrl("olive-young");
	const logoImage = getCanvasImageUrl("logo");

	const introText = page?.texts?.[1]?.content;
	const titleOverlay = page?.texts?.[2]?.content;
	const cheonggyecheonTitle = page?.texts?.[3]?.content;
	const cheonggyecheonDesc = page?.texts?.[4]?.content;
	const mercadoTitle = page?.texts?.[5]?.content;
	const mercadoDesc = page?.texts?.[6]?.content;
	const myeongdongTitle = page?.texts?.[7]?.content;
	const myeongdongDesc = page?.texts?.[8]?.content;
	const oliveTip = page?.texts?.[9]?.content;
	const myeongdongComoLlegar = page?.texts?.[10]?.content;
	const sabiasQueCheonggyecheon1 = page?.texts?.[11]?.content;
	const sabiasQueCheonggyecheon2 = page?.texts?.[12]?.content;
	const sabiasQueMercado = page?.texts?.[13]?.content;

	let actualHeaderColor = headerBackgroundColor || "#2E8B80";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{(portadaImage || titleOverlay || myeongdongSticker) && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					{portadaImage && (
						<img
							src={portadaImage}
							alt=""
							style={{ width: "100%", height: 200, objectFit: "cover" }}
						/>
					)}
					{titleOverlay && (
						<Box
							component="h1"
							sx={{
								fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
								fontSize: "32px",
								textAlign: "center",
								position: "absolute",
								bottom: "0",
								margin: "10px",
								left: "20px",
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{titleOverlay}
						</Box>
					)}
					{myeongdongSticker && (
						<img
							src={myeongdongSticker}
							alt=""
							style={{ width: 90, position: "absolute", bottom: 50, left: 25 }}
						/>
					)}
				</Box>
			)}

			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "10px 12px", position: "relative" }}>
					<Box component="p" sx={p}>
						{introText}
					</Box>
				</Box>
			)}

			{/* SECCIONES DESTACADAS */}
			<Box
				sx={{
					padding: "0 12px",
					display: "flex",
					flexDirection: "column",
					gap: "12px",
					marginTop: "8px",
				}}
			>
				{(cheonggyecheonTitle || cheonggyecheonDesc || cheonggyecheonImage) && (
					<Box data-block-id="text-2" sx={{ display: "flex", gap: "16px", position: "relative" }}>
						{cheonggyecheonImage && (
							<Box
								sx={{ display: "flex", flexDirection: "column", width: "40%" }}
							>
								<img
									src={cheonggyecheonImage}
									alt=""
									style={{
										width: "100%",
										height: 100,
										borderRadius: 12,
										objectFit: "cover",
									}}
								/>
							</Box>
						)}
						{sabiasQueCheonggyecheon1 && (
							<Box
								sx={{
									position: "absolute",
									bottom: isSmallScreen ? 52 : 40,
									left: isSmallScreen ? "30%" : "34%",
									zIndex: 30,
								}}
							>
								<SabiasQue icono="🏗️" texto={sabiasQueCheonggyecheon1} />
							</Box>
						)}
						{sabiasQueCheonggyecheon2 && (
							<Box
								sx={{
									position: "absolute",
									bottom: isSmallScreen ? 12 : 0,
									left: isSmallScreen ? "30%" : "34%",
									zIndex: 20,
								}}
							>
								<SabiasQue icono="🌙" texto={sabiasQueCheonggyecheon2} />
							</Box>
						)}
						<Box
							sx={{ width: "60%", display: "flex", flexDirection: "column" }}
						>
							{cheonggyecheonTitle && (
								<Box component="h3" sx={h3}>
									{cheonggyecheonTitle}
								</Box>
							)}
							{cheonggyecheonDesc && (
								<Box component="p" sx={p}>
									{cheonggyecheonDesc}
								</Box>
							)}
						</Box>
					</Box>
				)}

				{(mercadoTitle || mercadoDesc || mercadoSticker) && (
					<Box
						data-block-id="text-3"
						sx={{
							backgroundColor: "#caeae6",
							padding: "12px",
							borderRadius: "12px",
							display: "flex",
							gap: "16px",
							alignItems: "center",
							position: "relative",
						}}
					>
						<Box sx={{ paddingLeft: "8px" }}>
							{mercadoTitle && (
								<Box component="h3" sx={h3}>
									{mercadoTitle}
								</Box>
							)}
							{mercadoDesc && (
								<Box component="p" sx={p}>
									{mercadoDesc}
								</Box>
							)}
						</Box>
						{mercadoSticker && (
							<img src={mercadoSticker} alt="" style={{ width: 100 }} />
						)}
						{sabiasQueMercado && (
							<Box
								sx={{
									position: "absolute",
									top: isSmallScreen ? -20 : -12,
									right: isSmallScreen ? "40%" : "50%",
									zIndex: 10,
								}}
							>
								<SabiasQue icono="🥢" texto={sabiasQueMercado} />
							</Box>
						)}
					</Box>
				)}

				{(myeongdongTitle || myeongdongDesc || oliveYoungImage) && (
					<Box
						data-block-id="text-4"
						sx={{
							display: "flex",
							gap: "16px",
							justifyContent: "flex-end",
							width: "100%",
							position: "relative",
							marginTop: isSmallScreen ? "110px" : "4px",
						}}
					>
						{oliveYoungImage && (
							<img
								src={oliveYoungImage}
								alt=""
								style={{
									width: 110,
									position: "absolute",
									bottom: isSmallScreen ? "auto" : 0,
									left: isSmallScreen ? -25 : -10,
									top: isSmallScreen ? -100 : "auto",
								}}
							/>
						)}
						{oliveTip && (
							<Box
								sx={{
									position: "absolute",
									bottom: isSmallScreen ? "auto" : 80,
									top: isSmallScreen ? -130 : "auto",
									left: isSmallScreen ? 65 : 18,
									backgroundColor: "#fff8db",
									border: "2px solid #f5c400",
									borderRadius: "16px 16px 16px 0px",
									padding: "10px 12px",
									fontSize: 11,
									fontFamily: "'Poppins', sans-serif",
									color: "#444",
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: isSmallScreen ? 220 : 160,
								}}
							>
								{oliveTip}
							</Box>
						)}
						<Box
							sx={{
								backgroundColor: "#caeae6",
								border: "3px solid #2e8b80",
								borderRadius: "12px",
								padding: "8px 20px",
								fontSize: 12,
								fontFamily: "'Poppins', sans-serif",
								color: "#333",
								width: isSmallScreen ? "100%" : "70%",
							}}
						>
							{myeongdongTitle && (
								<Box
									component="h4"
									sx={{
										margin: 0,
										marginBottom: "8px",
										fontSize: 13,
										fontWeight: 700,
										display: "flex",
										alignItems: "center",
										gap: 6,
										color: "#2e8b80",
										textTransform: "uppercase",
									}}
								>
									{myeongdongTitle}
								</Box>
							)}
							{myeongdongDesc && (
								<Box component="p" sx={p}>
									{myeongdongDesc}
								</Box>
							)}
							{myeongdongComoLlegar && (
								<>
									<br />
									<span
										dangerouslySetInnerHTML={{ __html: myeongdongComoLlegar }}
									/>
								</>
							)}
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template132.thumbnail = "/images/template-1.png";

export default Template132;
